// Constants
import {
  DATE_SEPARATOR,
  PRIVACY_POLICY_LINK_OTHERS,
  PRIVACY_POLICY_LINK_SPAIN,
} from './constants/contract.view.utils.constants';
// Enums
import { ContractConsentsTypeEnum } from 'containers/contract/types/contract-api-data-api-response.type';
import { CountriesLocaleEnum } from '@openbank/ziniaweb-ui-core-models';
// Types
import { ContractConsentViewType } from '../hooks/types/contract.view.hook.types';
// Utils
import { getLocaleFromBrowser } from '@openbank/cf-ui-framework';

const getFormattedDate = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(DATE_SEPARATOR, '0');
  const month = String(today.getMonth() + 1).padStart(DATE_SEPARATOR, '0');
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};

const shouldShowSepaDescription = (consents: ContractConsentViewType[]): boolean =>
  consents && consents.some(({ type }) => type === ContractConsentsTypeEnum.SEPA_MANDATE);

const getPrivacyPolicyLink = (): string =>
  getLocaleFromBrowser() === CountriesLocaleEnum.ENGLAND
    ? PRIVACY_POLICY_LINK_OTHERS
    : PRIVACY_POLICY_LINK_SPAIN;

export { getFormattedDate, getPrivacyPolicyLink, shouldShowSepaDescription };
